import React, { useEffect, useState } from 'react';
import './Hero.css';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import HeroImage from '../../assets/images/hero image.png';
import iphonemockup1 from '../../assets/images/heromockup1.png';
import mockupvideo from '../../assets/videos/mockup video.mp4'
import CoinImage from '../../assets/images/coin.png';
import { motion } from 'framer-motion';
import '../../styles/variables.css'
import { useLanguage } from "../../contexts/LanguageContext";


function Hero() {
  const [coins, setCoins] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const { translations: t } = useLanguage();
  
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth < 768);
  //   };

  //   handleResize(); // Set initial value
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  useEffect(() => {
    const createCoins = () => {
      const coinCount = isMobile ? 4 : 8;
      return Array.from({ length: coinCount }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        startY: -50 - Math.random() * 100, 
        endY: window.innerHeight + 50,
        rotation: Math.random() * 360,
        duration: 3 + Math.random() * 2,
        delay: Math.random() * 1, 
        size: isMobile ? 15 + Math.random() * 15 : 20 + Math.random() * 30 // Smaller coins on mobile
      }));
    };

    setCoins(createCoins());
  }, [isMobile]);

  return (
    <section className="hero">
      <div className="coin-container">
        {coins.map((coin) => (
          <motion.img
            key={coin.id}
            src={CoinImage}
            alt="coin"
            className="coin"
            initial={{ 
              y: `${coin.startY}px`,
              x: `${coin.x}%`,
              rotate: 0,
              opacity: 0
            }}
            animate={{ 
              y: `${coin.endY}px`,
              rotate: 360,
              opacity: [0, 1, 1, 0]
            }}
            transition={{ 
              y: { duration: coin.duration, ease: "linear" },
              rotate: { duration: coin.duration, ease: "linear" },
              opacity: { 
                duration: coin.duration, 
                times: [0, 0.1, 0.9, 1],
                ease: "easeInOut" 
              }
            }}
            style={{
              position: 'absolute',
              zIndex: 2,
              width: `${coin.size}px`,
              height: `${coin.size}px`,
              left: `${coin.x}%`,
            }}
          />
        ))}
      </div>
      <div className="hero-arc"></div>
      <div className="hero-content search-card-home">
        <motion.div
          className="hero-text "
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>
            {t.socialMedia || "A new space for expression... and sharing ideas and creations."}<br />
            
          </h1>
          <p> {t.shareMoments || "A platform that bridges personal identity and professional growth. Share your inspiring moments, build your brand, and become part of an interactive experience that resonates with your ambition."}
              
          </p>
          <div className="hero-buttons">
            <a  href="https://apps.apple.com/ao/app/iwinto/id6482291656"                
                target="_blank" 
                rel="noopener noreferrer"
                className="store-button apple">
              <FaApple className="icon-apple" />
              <div>
               <span>{t.downloadOn || "Download On"}</span>
              <strong>{t.appStore || "App Store"}</strong>
              </div>
            </a>
            <a  href="https://play.google.com/store/apps/details?id=com.winto.app" 
                target="_blank" 
                rel="noopener noreferrer" className="store-button google">
              <FaGooglePlay className="icon" />
              <div>
                <span>{t.downloadOn || "Download On"}</span>
                <strong>{t.playStore || "Play Store"}</strong>
              </div>
            </a>
          </div>
        </motion.div>

       
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <video
              className="mockup-video"
              src={mockupvideo}
              autoPlay
              loop
              muted
              playsInline
            />
            <img src={iphonemockup1} alt="App showcase" />
          </motion.div>
       
      </div>
    </section>
  );
}

export default Hero;